import DocumentSchema from '@/components/DocumentSchema';
import type { Table } from 'schema-dts';
import ChartDataTable from '@/pages/CompanyReport/components/Overview/components/ChartDataTable';
import { shallowEqual, useSelector } from 'react-redux';
import selector from '../selector';

const NextDividendTable = () => {
  const selected = useSelector<
    Parameters<typeof selector>[0],
    ReturnType<typeof selector>
  >(selector, shallowEqual);

  const heading = `${selected?.companyName} dividend dates`;
  const caption = `When do you need to buy ${selected?.tickerSymbol} by to receive an upcoming dividend?`;

  return (
    <>
      <DocumentSchema<Table>
        item={{
          '@context': 'https://schema.org',
          '@type': 'Table',
          headline: heading,
          about: caption,
        }}
      />
      <ChartDataTable
        data-cy-id="overview-dividend-table"
        columnTextAlignments="l"
      >
        <caption>{caption}</caption>
        <thead>
          <tr>
            <th colSpan={2}>{heading}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Ex Dividend Date</td>
            <td>{selected?.dividendNextDateFormatted}</td>
          </tr>
          <tr>
            <td>Dividend Pay Date</td>
            <td>{selected?.dividendNextPayDateFormatted}</td>
          </tr>
          <tr>
            <td>Days until Ex dividend</td>
            <td>{selected?.daysUntilNextDate}</td>
          </tr>
          <tr>
            <td>Days until Dividend pay date</td>
            <td>{selected?.daysUntilNextPayDate}</td>
          </tr>
        </tbody>
      </ChartDataTable>
    </>
  );
};

export default NextDividendTable;
